// extracted by mini-css-extract-plugin
export default {"container":"AddressResults_container__xu9e1","heading":"AddressResults_heading__1iZF+","results":"AddressResults_results__afIcR"};